import { AxiosResponse } from "axios";

export const PRINT_DESIGN_MISSING_MANDATORY_ERROR_CODE =
  "PrintDesignMissingMandatoryPlaceholders";

export const PRINT_DESIGN_MISSING_MANDATORY_FOR_PRINT_ERROR_CODE =
  "PrintDesignMissingMandatoryFieldsForPrint";

const CUSTOMER_INVOICE_PRINT_URL = "get-print-ticket-document";
const CUSTOMIZATION_PRINT_URL = "get-print-ticket-customized-documents";

export function isPrintDesignMissingMandatoryError(
  response?: AxiosResponse,
): boolean {
  const code = response?.data?.code;
  return (
    code === PRINT_DESIGN_MISSING_MANDATORY_ERROR_CODE ||
    code === PRINT_DESIGN_MISSING_MANDATORY_FOR_PRINT_ERROR_CODE
  );
}

export function isCustomerInvoicePrintRequest(requestUrl?: string): boolean {
  return (
    !!requestUrl?.includes(CUSTOMER_INVOICE_PRINT_URL) &&
    !requestUrl.includes(CUSTOMIZATION_PRINT_URL)
  );
}

export function isCustomizationPrintRequest(requestUrl?: string): boolean {
  return !!requestUrl?.includes(CUSTOMIZATION_PRINT_URL);
}

export function shouldShowCustomerInvoiceMissingMandatoryDialog(
  response?: AxiosResponse,
  requestUrl?: string,
): boolean {
  return (
    isCustomerInvoicePrintRequest(requestUrl) &&
    isPrintDesignMissingMandatoryError(response)
  );
}

export function shouldSuppressPrintErrorNotification(
  response?: AxiosResponse,
  requestUrl?: string,
): boolean {
  return (
    isCustomizationPrintRequest(requestUrl) &&
    isPrintDesignMissingMandatoryError(response)
  );
}

export function handlePrintDesignMissingMandatoryError(
  response: AxiosResponse | undefined,
  requestUrl: string | undefined,
  showDialog: () => void,
): boolean {
  if (!shouldShowCustomerInvoiceMissingMandatoryDialog(response, requestUrl)) {
    return false;
  }

  showDialog();
  return true;
}
